
export const basicProgressData = [
    {
        class: 'primary',
        length: '25'
    },
    {
        class: 'secondary',
        length: '50'
    },
    {
        class: 'success',
        length: '75'
    },
    {
        class: 'info',
        length: '100'
    }
]

export const stripedProgressData = [
    {
        class: 'warning',
        length: '25'
    },
    {
        class: 'danger',
        length: '50'
    },
    {
        class: 'success',
        length: '75'
    }
]

export const customProgressData = [
    {
        text: '30% Getting Uploading...',
        class: 'primary',
        length: '30',
        strip:true
    },
    {
        text: '60% Getting Pause...',
        class: 'secondary',
        length: '60',
        strip:false
    },
    {
        text: '70% Getting Uploading...',
        class: 'success',
        length: '70',
        strip:true
    },
    {
        text: '100% Completed',
        class: 'dark',
        length: '100',
        strip:true
    }
]

export const smallProgressData = [
    {
        length: '30%',
        text: '30 MB Data'
    },
    {
        length: '50%',
        text: '50 MB Data'
    },
    {
        length: '75%',
        text: '75 MB Data'
    },
    {
        length: '100%',
        text: '100 MB Data'
    }
]

export const largeProgressData = [
    {
        class: 'secondary',
        length: '50'
    },
    {
        class: 'success',
        length: '75'
    },
    {
        class: 'info',
        length: '100'
    }
]

export const customHeightData = [
    {
        text: ' 5',
        class: 'warning',
        length: '50'
    },
    {
        text: ' 11',
        class: 'danger',
        length: '75'
    },
    {
        text: ' 19',
        class: 'info',
        length: '100'
    }
]